export default "__VITE_ASSET__9bi8Ll$L__"